import React, { useContext } from 'react'
import Auth from '../components/page/Auth'
import { AppContext } from '../lib'
import { Redirect } from 'react-router-dom'

export default function AuthRoute() {
  const {state} = useContext(AppContext)
  const {accessToken} = state
  return !!accessToken ? <Redirect to='/main'/>  : <Auth />
}